import {Grid, Alert} from "@mui/material"
import { SeccionContraparteDatosOperacion, SeccionContraparteCuentas } from './components';
import { useContext, useEffect } from "react";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "src/hooks/useLoader";
import { EntityWithIdFields, QueryStatus } from "src/types";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import { FormOperacionContraparte, OperacionContraparte, schemaFormOperacionContraparte } from "./types/types";
import { HttpContraparte } from "./api/httpContraparte";
import { useOperacionContraparte } from "./hooks/useOperacionContraparte";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import {SistemaTipo} from "../../../../types/enum/enum";

type SistemaContraparteContentProps = {
    operacion: OperacionContraparte,
}

const SistemaContraparteContent = ({ operacion }: SistemaContraparteContentProps) => {

    const { setSavePromise, codSistemaTipo: codSistema } = useContext<ContextOperacionType>(ContextOperacion)

    const formMethods = useForm<FormOperacionContraparte>({
        resolver: zodResolver(schemaFormOperacionContraparte),
        values: { ...operacion }
    })

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (operacion.permiteEditarOperacion) {
            const handleSave: SubmitHandler<FormOperacionContraparte> = (data) => {
                showLoader()
                const promise = HttpContraparte.put(operacion[EntityWithIdFields.Id], data)

                toast.promise(promise, {
                    loading: 'Guardando.',
                    success: 'Guardado correctamente.',
                    error: e => `${e}`
                }).finally(hideLoader)
            }

            const onSave = () => formMethods.handleSubmit(handleSave)
            setSavePromise(onSave)
        }
    }, [])


    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <SeccionContraparteDatosOperacion
                        formMethods={formMethods}
                        readOnly={!operacion.permiteEditarOperacion}
                        operacion={operacion}
                        codSistemaPrincipal={operacion.codPais}
                        codSistema={codSistema}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionContraparteCuentas
                        idOperacion={operacion[EntityWithIdFields.Id]}
                        idPais={operacion.codPais}
                        permiteEditar={operacion.permiteEditarOperacion}
                        permiteEliminar={operacion.permiteEliminarOperacion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionFirmas
                        codSistema={SistemaTipo.Contrapartes}
                        idOperacion={operacion[EntityWithIdFields.Id]}
                    />
                </Grid>
            </Grid>
        </>
    )
}


export const SistemaContraparte = () => {

    const { idOperacion } = useContext<ContextOperacionType>(ContextOperacion)

    const { status, operacion } = useOperacionContraparte(idOperacion)

    const { showLoader, hideLoader } = useLoader()

    useEffect(() => {
        if (status === QueryStatus.Loading) {
            showLoader()
        } else {
            hideLoader();
        }
    }, [status])

    if (!operacion) {
        return (
            <></>
        )
    }

    if (status === QueryStatus.Error) {
        return (
            <Alert severity='error'>
                Se produjo un error al cargar la operación.
            </Alert>
        )
    }

    return (
        <SistemaContraparteContent
            operacion={operacion}

        // setSavePromise={setSavePromise}
        // setCrearInforme={setCrearInforme}
        />
    )
}
